// import React, { useEffect, useRef } from "react";
// import { Modal } from "bootstrap"; // ✅ correct import
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// const BootstrapModal = ({
//   id = "customModal",
//   title = "Modal Title",
//   show = false,
//   onClose,
//   onSave,
//   children,
//   footer,
//   size = "md", // sm | lg | xl
//   backdrop = true,
//   keyboard = true,
// }) => {
//   const modalRef = useRef(null);
//   const bsModal = useRef(null);

//   useEffect(() => {
//     if (modalRef.current) {
//       const bootstrap = window.bootstrap;
//       bsModal.current = new bootstrap.Modal(modalRef.current, {
//         backdrop: backdrop ? true : "static",
//         keyboard,
//       });

//       if (show) {
//         bsModal.current.show();
//       } else {
//         bsModal.current.hide();
//       }
//     }
//   }, [show, backdrop, keyboard]);

//   // Close handler
//   const handleClose = () => {
//     if (onClose) onClose();
//     bsModal.current?.hide();
//   };

//   const handleSave = () => {
//     if (onSave) onSave();
//   };

//   return (
//     <div
//       className="modal fade"
//       id={id}
//       tabIndex="-1"
//       aria-labelledby={`${id}-label`}
//       aria-hidden="true"
//       ref={modalRef}
//     >
//       <div className={`modal-dialog modal-${size} modal-dialog-centered`}>
//         <div className="modal-content">
//           {/* Header */}
//           <div className="modal-header">
//             <h5 className="modal-title" id={`${id}-label`}>
//               {title}
//             </h5>
//             <button
//               type="button"
//               className="btn-close"
//               onClick={handleClose}
//               aria-label="Close"
//             ></button>
//           </div>

//           {/* Body */}
//           <div className="modal-body">
//             {children ? children : <p>This is the default modal body.</p>}
//           </div>

//           {/* Footer */}
//           <div className="modal-footer">
//             {footer ? (
//               footer
//             ) : (
//               <>
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={handleClose}
//                 >
//                   Close
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleSave}
//                 >
//                   Save changes
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// BootstrapModal.propTypes = {
//   id: PropTypes.string,
//   title: PropTypes.string,
//   show: PropTypes.bool,
//   onClose: PropTypes.func,
//   onSave: PropTypes.func,
//   children: PropTypes.node,
//   footer: PropTypes.node,
//   size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
//   backdrop: PropTypes.bool,
//   keyboard: PropTypes.bool,
// };

// export default BootstrapModal;

import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Modal } from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const BootstrapModal = ({
  id = "customModal",
  title = "Modal Title",
  show = false,
  onClose,
  onSave,
  buttonText,
  buttonColor,
  children,
  footer,
  size = "md", // sm | lg | xl
  backdrop = true,
  keyboard = true,
}) => {
  const modalRef = useRef(null);
  const bsModal = useRef(null);

  useEffect(() => {
    if (!modalRef.current) return;

    // ✅ Use imported Modal, not window.bootstrap
    bsModal.current = new Modal(modalRef.current, {
      backdrop: backdrop ? true : "static",
      keyboard,
    });

    if (show) {
      bsModal.current.show();
    } else {
      bsModal.current.hide();
    }

    return () => {
      bsModal.current?.hide();
    };
  }, [show, backdrop, keyboard]);

  const handleClose = () => {
    bsModal.current?.hide();
    onClose?.();
  };

  const handleSave = () => {
    onSave?.();
  };

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-labelledby={`${id}-label`}
      aria-hidden="true"
      ref={modalRef}
    >
      <div className={`modal-dialog modal-${size} modal-dialog-centered`}>
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title" id={`${id}-label`}>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            {children || <p>This is the default modal body.</p>}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            {footer ? (
              footer
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className={`btn btn-${buttonColor || "danger"}`}
                  onClick={handleSave}
                >
                  {buttonText || "Delete"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

BootstrapModal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  backdrop: PropTypes.bool,
  keyboard: PropTypes.bool,
};

export default BootstrapModal;
